import { ChartTypes } from '@mode/shared/contract-common';
import { DEFAULT_CHART_FORMAT } from '@mode/shared/util-js';

// For keeping functions that mutate the ChartFormat blob

function getFormatOrDefault(format: ChartTypes.ChartFormat) {
  return format || DEFAULT_CHART_FORMAT;
}

function getBigValueFormatOrDefault(format: ChartTypes.ChartFormat) {
  return format.bigValue || DEFAULT_CHART_FORMAT.bigValue;
}

export function updateBigValueTrendLabel(format: ChartTypes.ChartFormat, label: string) {
  format = getFormatOrDefault(format);
  const valueFormat = getBigValueFormatOrDefault(format);

  return {
    ...format,
    bigValue: {
      ...valueFormat,
      primaryTrendFormat: {
        ...valueFormat.primaryTrendFormat,
        label,
      },
    },
  };
}

export function updateTextFormatProp<K extends keyof ChartTypes.TextFormat>(
  format: ChartTypes.TextFormat,
  key: K,
  value: ChartTypes.TextFormat[K]
) {
  return {
    ...format,
    [key]: value,
  };
}
